// extracted by mini-css-extract-plugin
export default {"rating":"Iw-z","numberOfStars":"Jw-z","count":"Kw-z","barGraphSpacing":"Lw-z","barGraph":"Mw-z"};